<script lang="ts">
	import Meta from '$lib/components/Meta.svelte';
	import { page } from '$app/stores';
	import SearchFilter from '$lib/components/platform/SearchFilter.svelte';
	import FullVideoList from '$lib/components/platform/pages/videos/VideoList.svelte';
	import VideoFilterBtnList from '$lib/components/platform/VideoFilterBtnList.svelte';

	export let data;
</script>

<Meta
	title={$page.data.sector.title}
	description={$page.data.sector.description}
	image={$page.data.sector.public_image_url}
/>

<div class="space-y-2">
	<VideoFilterBtnList sectors={data.sectors} class="mb-16" />
	<h1 class="text-3xl">{$page.data.sector.name}</h1>
	<div class="flex items-center justify-between">
		<div class="flex w-full flex-col items-center justify-between gap-4 sm:flex-row">
			<div class="w-full grow lg:w-auto">
				<SearchFilter placeholder="Search" value={$page.url.searchParams.get('search') || ''} />
			</div>
			<!-- <div class="flex w-full grow justify-end gap-2">
				<Button color="red" size="sm">Videos</Button>
				<a href="/playlists/sector/{$page.data.sector.slug}">
					<Button color="gray" size="sm">Playlists</Button>
				</a>
			</div> -->
		</div>
	</div>
</div>

<main class="mt-8">
	<FullVideoList />
</main>
